import React from 'react'

export default function FilterMarginRange({ value, operator, onValueChange, onOperatorChange }) {
	return (
		<div className="d-flex align-items-center mr-2">
			<select className="form-control form-control-sm mr-2"
				value={operator}
				onChange={(e) => onOperatorChange(e.target.value)}
			>
				<option value="GT">Greater than &gt;</option>
				<option value="LT">Less than &lt;</option>
			</select>

			<div className="position-relative w-100">
				<span
					style={{
						position: 'absolute',
						left: 5,
						top: '50%',
						transform: 'translateY(-50%)',
						color: '#6c757d',
					}}
				>
					$
				</span>
				<input
					type="number"
					className="form-control form-control-sm pl-4"					
					value={value}
					style={{width: '100%'}}
					onChange={(e) => onValueChange(e.target.value)}
				/>
			</div>
		</div>
	)
}
